require('./stepsView.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ actions
const RASuitabilityTestWizardActions = require('actions/RASuitabilityTestWizardActions');
const RASuitabilityTest = require('actions/RASuitabilityTest');
const formActions = require('react-redux-form').actions;
// @ components
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
const RARadialMenu = require('components/RAComponents/commons/RARadialMenu/RARadialMenu');
// @ utilities
import { formatText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
// @ constants
const { PATH_ROBO_TI, PATH_GBI_TI } = require('constants/uTagConstants/paths');
const { SUITABILITY_TEST_PROFILE_MODEL_ANSWERS } = require('constants/RAConstants/index');
const {
    TEST_PROCESS_STEP_STEP_5,
    EVENT_DETAIL_SUITABILITY_TEST_INVESTMENT_GOAL,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_QUESTION_LOAD,
    EVENT_DETAIL_TOOLTIP,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_BUTTON_NEXT,
} = require('constants/uTagConstants/RAConstants');
const { ROBO } = require('constants/userProfile');

class RAGoalOfInvestmentStepComponent extends React.Component {
    constructor(props) {
        super(props);

        this.onHandleContinueButton = this.onHandleContinueButton.bind(this);
        this.onHandlePrevButton = this.onHandlePrevButton.bind(this);
        this.handleOnRadialItemClick = this.handleOnRadialItemClick.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_5,
            EVENT_DETAIL_QUESTION_LOAD,
            userProfile
        );
    }

    handleOnClickTooltip = () => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_5,
            EVENT_DETAIL_TOOLTIP,
            userProfile
        );
    };

    onHandleContinueButton() {
        const { RATestWizard, raSuitabilityTestWizardActions, raSuitabilityTest, userProfile } = this.props;
        const { currentStep, currentSubStep, lastSubStep } = RATestWizard;
        const isFinalized = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].finished;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
        const data = {
            step: currentStep,
            substep: currentSubStep,
        };
        const answerValue = userProfile?.RASuitabilityTest?.answers?.[questionID] ?? undefined;
        const answerLabel = EVENT_DETAIL_SUITABILITY_TEST_INVESTMENT_GOAL[answerValue];

        if (isFinalized) {
            raSuitabilityTest.resetCoherenceError();
            raSuitabilityTestWizardActions.nextStep(data);
        } else if (lastSubStep) {
            raSuitabilityTestWizardActions.finishStep(data);
        } else {
            raSuitabilityTestWizardActions.finishSubStep(data);
        }

        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_5,
            `${EVENT_DETAIL_BUTTON_NEXT}, ${answerLabel}`,
            userProfile
        );
    }

    onHandlePrevButton() {
        const { RATestWizard, raSuitabilityTestWizardActions, userProfile } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const data = {
            currentStep,
            currentSubStep,
        };

        raSuitabilityTestWizardActions.prevStep(data);

        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_5,
            EVENT_DETAIL_BUTTON_PREV,
            userProfile
        );
    }

    handleOnRadialItemClick(value) {
        const { RATestWizard, formActions, userProfile } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;

        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${questionID}`, value);

        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_5,
            EVENT_DETAIL_SUITABILITY_TEST_INVESTMENT_GOAL[value],
            userProfile
        );

        return value;
    }

    getContent(questionID) {
        const { immSuitabilityTest, userProfile } = this.props;
        const question = immSuitabilityTest.getIn(['questions', questionID]);
        const title = question.get('title');
        const answers = question.get('answers').toJS();
        const value = userProfile?.RASuitabilityTest?.answers?.[questionID] ?? '';

        return (
            <RARadialMenu
                onRadialItemClick={this.handleOnRadialItemClick}
                selectedValue={value}
                title={title}
                disabled={false}
                values={answers}
                tooltipContent={formatText('suitabilityTest-tooltipObjectivesStep1')}
                onClickTooltip={this.handleOnClickTooltip}
            />
        );
    }

    isDisabled(questionID) {
        const { userProfile } = this.props;

        return !userProfile?.RASuitabilityTest?.answers?.[questionID];
    }

    render() {
        const { RATestWizard } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
        const content = this.getContent(questionID);
        const disabled = this.isDisabled(questionID);

        return (
            <div>
                <div className="steps-view">{content}</div>
                <hr />
                <div className="steps-view__footer">
                    <RoadmapNavigation
                        buttonContinueType="submit"
                        buttonContinueAction={this.onHandleContinueButton}
                        buttonContinueText={formatText('suitabilityTest-next')}
                        buttonPrevText={formatText('suitabilityTest-prev')}
                        buttonCancelText={formatText('suitabilityTest-getOut')}
                        buttonPrevAction={this.onHandlePrevButton}
                        buttonContinueDisabled={disabled}
                    />
                </div>
            </div>
        );
    }
}

export const RAGoalOfInvestmentStep = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        raSuitabilityTestWizardActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
    })
)(RAGoalOfInvestmentStepComponent);
